import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FilterValuesContainer} from '../../../interface/FilterValuesContainer';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

export class FilterSearchValue implements FilterValuesContainer {
    public search = '';

    public constructor(search: string = '') {
        this.search = search;
    }

    applyFilters(url: URL): URL {
        if (this.search != '') {
            url.searchParams.append('search', this.search);
        }
        return url;
    }
}

@Component({
    selector: 'app-filter-search',
    templateUrl: './filter-search.component.html',
    imports: [MatFormField, MatLabel, MatInput, FormsModule, MatIcon, MatSuffix, TranslateModule]
})
export class FilterSearchComponent {

    public search: string;
    public _timeout = null;

    @Output('onChange') filtersValuesChange = new EventEmitter<FilterSearchValue>();

    @Input('filterSearchValue') set defaultValue(item: FilterSearchValue) {
        if (item) {
            this.search = item.search;
        }
    }

    @Input() theme = 'legacy';
    @Input() color = 'primary';
    @Input() floatLabel = 'auto';
    @Input() label = 'general.rechercher';
    @Input() placeholder = 'front.dossier.numeroDossierNom';
    @Input() debounceTime = 400;


    public onChangeResearch() {
        if (this._timeout) {
            //if there is already a timeout in process cancel it
            window.clearTimeout(this._timeout);
        }

        this._timeout = setTimeout(() => {
            this.outputValue();
        }, this.debounceTime);
    }

    private outputValue(): void {
        this.filtersValuesChange.emit(
            new FilterSearchValue(
                this.search
            )
        );
    }
}
